export default "__VITE_ASSET__IugFscCO__"